import { Configuration, UsersApi } from '@/api';
import useGetStoreQuery from '@/api/queries/useGetStoreQuery';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import useUserQuery from '@/modules/settings/hooks/useUserQuery';
import UserProfileForm from '@/modules/store/components/UserProfileForm';
import { User } from '@/modules/store/models/User';
import { UserIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const Profile = () => {
  const { currentUser } = useAuth();

  const { storeId } = currentUser();

  const { user, isLoading: isLoadingUser, invalidateQuery } = useUserQuery();

  const { store, isLoading: isLoadingStore } = useGetStoreQuery(storeId);

  const usersApi = new UsersApi(new Configuration(useAuth));

  const handleSubmitUserProfile = async (user: User) => {
    try {
      await usersApi.updateUser(user.id, user);

      toast.custom((t) => (
        <CustomToast id={t.id} message={'Profile updated successfully!'} visible={t.visible} />
      ));

      await invalidateQuery();
    } catch (error) {
      console.error('Error while updating user:', error);
    }
  };

  if (isLoadingUser || isLoadingStore) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!user) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Profile" icon={<UserIcon className="w-6 h-6" />} />

      <UserProfileForm
        user={user}
        onSubmit={handleSubmitUserProfile}
        contactNumberCountryCode={store?.contactCountryCode}
        contactNumber={store?.contactNumber}
      />
    </>
  );
};

export default Profile;
